export default "/assets/images/uk-union-jack-lg.jpg?e4f942b941292314820d4df2328c739f";